import { forwardRef, useRef } from 'react'
import CreatableSelect from 'react-select/creatable'
import Select from 'react-select'

const SelectCreatable = forwardRef(function SelectCreatable(
    { id = '', label = '', placeholder = '', className = '', error = '', isCreatable = false, ...props },
    ref
) {
    const inputRef = useRef()
    const Component = isCreatable ? CreatableSelect : Select

    return (
        <div className={className}>
            {label && (
                <label htmlFor={id} className={`block mb-1 font-medium ${error ? 'text-danger' : 'text-black dark:text-white'}`}>
                    {label}
                </label>
            )}
            <div className="relative bg-white dark:bg-strokedark text-body">
                <Component
                    {...props}
                    id={id}
                    placeholder={label || placeholder}
                    closeMenuOnSelect={props.isMulti ? false : true}
                    tabSelectsValue={false}
                    blurInputOnSelect={!props.isMulti}
                    ref={ref ?? inputRef}
                    styles={{
                        input: base => ({
                            ...base,
                            'input:focus': { boxShadow: 'none' },
                        }),
                    }}
                />
            </div>
            {error && <p className="text-sm text-danger">{error}</p>}
        </div>
    )
})

export default SelectCreatable
